// src/hooks/useUserProfile.js

import { useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase"; // Import the Firestore instance

const useUserProfile = (uid) => {
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserProfile = async () => {
      if (!uid) {
        setLoading(false); // Exit if there is no UID
        return;
      }

      try {
        setLoading(true);
        const userDocRef = doc(db, "users", uid); // Reference to the user document
        const userDocSnap = await getDoc(userDocRef);

        if (userDocSnap.exists()) {
          setProfileData(userDocSnap.data());
        } else {
          setError("User profile not found");
        }
      } catch (err) {
        setError("Failed to fetch user profile");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchUserProfile();
  }, [uid]);

  return { profileData, loading, error };
};

export default useUserProfile;
